module.exports = __webpack_public_path__ + "img/Website_MAXIM_FinalRev.9e69bf9f.png";